export default __webpack_public_path__ + "static/horizontal-logo-5719f418e39f9b09d02cbefc53a4f5a0.png";